import React, { useEffect, useState } from 'react';
import VideoTaskContent from '../VideoTaskContent';
import { Dialog, useMediaQuery } from '@material-ui/core';
import { routeMappings } from '../../../constants';
import { useBasicDetails } from '../../../store';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import { VideoTaskConfiguration } from '../../interfaces/videoTask';
import { VideoTaskContentStyles } from '../../styles/videoTaskContent';

interface VideoTaskLayoutProps {
  getNextWorkflowItem?(): Promise<void>;
  videoTaskConfiguration: VideoTaskConfiguration;
}

const VideoTaskLayout = (props: VideoTaskLayoutProps): JSX.Element => {
  const history = useHistory();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { currentWorkflowItem: workflowItem } = useBasicDetails();
  const { getNextWorkflowItem, videoTaskConfiguration } = props;

  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(true);
    return (): void => {
      setOpen(false);
    };
  }, []);

  const classes = VideoTaskContentStyles({ backgroundColor: videoTaskConfiguration.popupBackgroundColor });

  const goBack = (): void => {
    history.push(`${routeMappings['TASKLIST']}/${workflowItem.id}`);
  };

  return (
    <Dialog
      className={classes.dialogContainer}
      fullScreen={fullScreen}
      open={open}
      onClose={goBack}
      aria-labelledby="dialog-title"
      disableBackdropClick
      disableEnforceFocus
      disableEscapeKeyDown>
      <VideoTaskContent
        getNextWorkflowItem={getNextWorkflowItem}
        videoTaskConfiguration={videoTaskConfiguration}
        open={open}
        goBack={goBack}
      />
    </Dialog>
  );
};

export default VideoTaskLayout;
